
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import getAttributeValueAsText from '../getAttributeValueAsText';

import ObjectDetailAttributeGeneric from './ObjectDetailAttributeGeneric';

const ObjectDetailAttributeText = ({attribute, dataModel, value}) => {

    const classNames = mergeStyleSets({
        value: {
            width: 150,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        }
    });

    const processedValue = getAttributeValueAsText(attribute, value);

    return (
        <ObjectDetailAttributeGeneric
            attribute={attribute}
            dataModel={dataModel}
            value={value}
            valueComponent={
                <Stack className={classNames.value} title={processedValue}>{processedValue}</Stack>
            }
        />
    );
}

export default ObjectDetailAttributeText;
